import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { saveFile, valsubstr32addbr } from '@/utils/index';
import windowHeightMixin from '@/mixins/windowHeightMixin';
export default {
  mixins: [windowHeightMixin],
  data: function data() {
    return {
      userOptions: [],
      userOptionLoading: false,
      roleId: null,
      systemId: null,
      activeTabName: 'BASIC',
      roleBasicInfo: {},
      rolePermissionData: [],
      rolePermissionPagination: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      permissionTableLoading: false,
      activeUserTabName: 'REGULAR',
      customizedUsers: [],
      customizedFilterForm: {
        userId: [],
        orgMap: [],
        manageOrgMap: [],
        bizLineList: []
      },
      dynamicFilterForm: {
        userId: [],
        orgMap: [],
        manageOrgMap: [],
        bizLineList: []
      },
      dynamicUserData: [],
      customizedUserFilterData: {
        orgMap: [],
        manageOrgMap: [],
        bizLineList: []
      },
      autoUserFilterData: {
        orgMap: [],
        manageOrgMap: [],
        bizLineList: []
      },
      customizedPagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      dynamicPagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      dictList: JSON.parse(sessionStorage.getItem('dist_info')),
      dictInfo: '',
      bizLineList: []
    };
  },
  created: function created() {
    var _this$$route$params = this.$route.params,
      roleId = _this$$route$params.roleId,
      systemId = _this$$route$params.systemId;
    this.roleId = roleId;
    this.systemId = systemId;
    this.getRoleBasicInfo();
    this.getRolePermissions(1, 10);
    this.getBusLines();
  },
  methods: {
    // 获取条线列表数据
    getBusLines: function getBusLines() {
      this.dictInfo = this.dictList.BUSINESS_LINE || null;
      var obj = this.dictInfo;
      if (this.dictInfo !== null) {
        // eslint-disable-next-line guard-for-in
        for (var i in obj) {
          this.bizLineList.push({
            key: i,
            value: obj[i]
          });
        }
      }
    },
    // ‘角色基本信息’ 和 ‘用户列表’ tab点击事件
    handleTabClick: function handleTabClick(instance) {
      if (instance.name === 'BASIC') {
        this.getRoleBasicInfo();
        this.getRolePermissions(1, 10);
      }
      if (instance.name === 'USERS') {
        this.activeUserTabName = 'REGULAR';
        this.getCustomizedUsers(this.roleId, 1, 10);
      }
    },
    // 固定用户列表 和 动态用户列表 tab点击事件
    handleSubTabClick: function handleSubTabClick(instance) {
      if (instance.name === 'REGULAR') {
        this.getCustomizedUsers(this.roleId, 1, 10);
        this.getUserFilterData('customizedUser');
      }
      if (instance.name === 'DYNAMIC') {
        this.getAutoUsers(1, 10);
        this.getUserFilterData('autoUser');
      }
    },
    // 获取角色基本信息
    getRoleBasicInfo: function getRoleBasicInfo() {
      var _this = this;
      this.$API.getRequest({
        url: '/platform/roleInner/detail',
        data: {
          roleId: this.roleId,
          systemId: this.systemId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this.roleBasicInfo = res.result;
        }
      });
    },
    // 筛选条件中，‘确定’按钮点击事件
    filterConfirm: function filterConfirm(type) {
      if (type === 'customizedUser') {
        this.getCustomizedUsers(this.roleId, 1, 10);
        this.$refs['customized-filter-popover'].doClose();
      }
      if (type === 'autoUser') {
        this.getAutoUsers(1, 10);
        this.$refs['dynamic-filter-popover'].doClose();
      }
    },
    resetFilterConfirm: function resetFilterConfirm() {
      this.customizedFilterForm = {
        userId: [],
        orgMap: [],
        manageOrgMap: [],
        bizLineList: []
      }, this.dynamicFilterForm = {
        userId: [],
        orgMap: [],
        manageOrgMap: [],
        bizLineList: []
      };
    },
    /**
     * @description 获取筛选条件数据
     * @param {String} type customizedUser | autoUser
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/13
     */
    getUserFilterData: function getUserFilterData(type) {
      var _this2 = this;
      var roleId = this.roleId;
      var systemId = this.systemId;
      var targetUserFilterData = type === 'customizedUser' ? this.customizedUserFilterData : this.autoUserFilterData;
      var data = {
        userLabelRuleId: this.roleBasicInfo.userLabelRuleId,
        roleId: roleId,
        systemId: systemId
      };
      this.$API.getRequest({
        url: "/platform/".concat(type, "/conditions"),
        data: data
      }).then(function (res) {
        if (res.code === '0000000000') {
          var _res$result = res.result,
            bizLineList = _res$result.bizLineList,
            manageOrgMap = _res$result.manageOrgMap,
            orgMap = _res$result.orgMap;
          targetUserFilterData.bizLineList = _this2.bizLineList.filter(function (item) {
            return bizLineList.includes(item.key);
          });
          targetUserFilterData.manageOrgMap = manageOrgMap;
          targetUserFilterData.orgMap = orgMap;
        }
      });
    },
    // 获取角色权限信息
    getRolePermissions: function getRolePermissions(pageNum, pageSize) {
      var _this3 = this;
      this.permissionTableLoading = true;
      this.$API.getRequest({
        url: "/platform/roleInner/permission/rolePermissionDetail/".concat(this.roleId),
        data: {
          systemId: this.systemId,
          pageNum: pageNum,
          pageSize: pageSize,
          roleId: this.roleId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this3.rolePermissionData = Array.isArray(res.result.records) && res.result.records;
          _this3.rolePermissionPagination.total = res.result.total;
        }
        _this3.permissionTableLoading = false;
      });
    },
    // 获取固定列表用户数据
    getCustomizedUsers: function getCustomizedUsers(roleId, pageNum, pageSize) {
      var _this4 = this;
      this.$API.postRequest({
        url: '/platform/customizedUser/list',
        data: {
          bizLineList: this.customizedFilterForm.bizLineList || [],
          manageOrgList: this.customizedFilterForm.manageOrgMap || [],
          orgIdList: this.customizedFilterForm.orgMap || [],
          pageNum: pageNum,
          pageSize: pageSize,
          roleId: roleId,
          userIdList: this.customizedFilterForm.userId || [],
          systemId: this.systemId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this4.customizedUsers = Array.isArray(res.result.records) && res.result.records;
          _this4.customizedUsers.forEach(function (item) {
            item.mngLevel = _this4.dictList.MANAGER_LEVEL[item.mngLevel];
          });
          _this4.customizedPagination.total = res.result.total;
        }
      });
    },
    // 获取动态人员数据
    getAutoUsers: function getAutoUsers(pageNum, pageSize) {
      var _this5 = this;
      var data = {
        bizLineList: this.dynamicFilterForm.bizLineList || [],
        manageOrgList: this.dynamicFilterForm.manageOrgMap || [],
        orgIdList: this.dynamicFilterForm.orgMap || [],
        pageNum: pageNum,
        pageSize: pageSize,
        systemId: this.systemId,
        userIdList: this.dynamicFilterForm.userId || [],
        userLabelRuleId: this.roleBasicInfo.userLabelRuleId,
        roleId: this.roleBasicInfo.roleId
      };
      this.$API.postRequest({
        url: '/platform/autoUser/list',
        data: data
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this5.dynamicUserData = Array.isArray(res.result.records) && res.result.records;
          _this5.dynamicUserData.forEach(function (item) {
            item.mngLevel = _this5.dictList.MANAGER_LEVEL[item.mngLevel];
          });
          _this5.dynamicPagination.total = res.result.total;
        }
      });
    },
    /**
     * @description 用户数据联想请求
     * @param {String} val 输入值
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/14
     */
    userRemoteMethod: function userRemoteMethod(val) {
      var _this6 = this;
      if (val === '') {
        return;
      }
      this.userOptionLoading = true;
      this.$API.getRequest({
        url: "/platform/component/userNameOrId/".concat(val),
        data: {}
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this6.userOptions = res.result;
        }
      }).finally(function () {
        _this6.userOptionLoading = false;
      });
    },
    // 导出功能
    exportTable: function exportTable(type) {
      var _this7 = this;
      var targetFilterForm = type === 'customized' ? this.customizedFilterForm : this.dynamicFilterForm;
      var targetPagination = type === 'customized' ? this.customizedPagination : this.dynamicPagination;
      var bizLineList = targetFilterForm.bizLineList,
        manageOrgList = targetFilterForm.manageOrgMap,
        orgIdList = targetFilterForm.orgMap;
      var pageSize = targetPagination.pageSize,
        pageNum = targetPagination.pageNum;
      var map = new Map([['customized', {
        url: '/platform/customizedUser/list/export',
        data: {
          bizLineList: bizLineList,
          manageOrgList: manageOrgList,
          orgIdList: orgIdList,
          pageNum: pageNum,
          pageSize: pageSize,
          roleId: this.roleId,
          userIdList: this.customizedFilterForm.userId || [],
          systemId: this.systemId
        }
      }], ['dynamic', {
        url: '/platform/autoUser/list/export',
        data: {
          bizLineList: bizLineList,
          manageOrgList: manageOrgList,
          orgIdList: orgIdList,
          pageNum: pageNum,
          pageSize: pageSize,
          systemId: this.systemId,
          userIdList: [],
          userLabelRuleId: this.roleBasicInfo.userLabelRuleId,
          roleId: this.roleBasicInfo.roleId
        }
      }]]);
      var _map$get = map.get(type),
        url = _map$get.url,
        data = _map$get.data;
      this.$API.postRequest({
        url: url,
        data: data
      }).then(function (res) {
        if (res.code === '0000000000') {
          return res.result;
        }
      }).then(function (_ref) {
        var filePath = _ref.filePath,
          exportMessage = _ref.exportMessage;
        if (!filePath) {
          if (exportMessage) {
            _this7.$message({
              message: exportMessage,
              type: 'success'
            });
          }
          return;
        }
        _this7.$API.getRequest({
          url: '/platform/file/templateDownload',
          data: {
            filePath: filePath
          },
          responseType: 'blob'
        }).then(function (res) {
          saveFile(res.data, '固定用户列表导出文件.xlsx');
        });
      });
    },
    // ‘角色权限列表’ pageNum回调事件
    rolePermissionCurrentChange: function rolePermissionCurrentChange(value) {
      this.rolePermissionPagination.pageNum = value;
      this.getRolePermissions(this.rolePermissionPagination.pageNum, this.rolePermissionPagination.pageSize);
    },
    // ‘角色权限列表’ pageSize回调事件
    rolePermissionSizeChange: function rolePermissionSizeChange(value) {
      this.rolePermissionPagination.pageNum = 1;
      this.rolePermissionPagination.pageSize = value;
      this.getRolePermissions(this.rolePermissionPagination.pageNum, this.rolePermissionPagination.pageSize);
    },
    // 固定人员列表 pageNum回调事件
    customizedCurrentChange: function customizedCurrentChange(value) {
      this.customizedPagination.pageNum = value;
      this.getCustomizedUsers(this.roleId, this.customizedPagination.pageNum, this.customizedPagination.pageSize);
    },
    // 固定人员列表 pageSize回调事件
    customizedSizeChange: function customizedSizeChange(value) {
      this.customizedPagination.pageNum = 1;
      this.customizedPagination.pageSize = value;
      this.getCustomizedUsers(this.roleId, this.customizedPagination.pageNum, this.customizedPagination.pageSize);
    },
    // 动态人员列表 pageNum回调事件
    dynamicCurrentChange: function dynamicCurrentChange(value) {
      this.dynamicPagination.pageNum = value;
      this.getAutoUsers(this.dynamicPagination.pageNum, this.dynamicPagination.pageSize);
    },
    // 动态人员列表 pageSize回调事件
    dynamicSizeChange: function dynamicSizeChange(value) {
      this.dynamicPagination.pageNum = 1;
      this.dynamicPagination.pageSize = value;
      this.getAutoUsers(this.dynamicPagination.pageNum, this.dynamicPagination.pageSize);
    },
    // 角色基本信息页 导出所有信息
    exportAll: function exportAll() {
      var _this8 = this;
      this.$API.postRequest({
        url: '/platform/roleInner/detail/export',
        data: {
          roleId: this.roleId,
          systemId: this.systemId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          return res.result.filePath;
        }
      }).then(function (filePath) {
        if (!filePath) {
          return;
        }
        _this8.$API.getRequest({
          url: '/platform/file/templateDownload',
          data: {
            filePath: filePath
          },
          responseType: 'blob'
        }).then(function (res) {
          saveFile(res.data, '角色详情导出文件.xlsx');
        });
      });
    },
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    }
  }
};